import React from 'react';
import ReactDom from 'react-dom';
import condoSetAction from '../../actions/condoSetAction';

class ModalCheckList extends React.Component {
    constructor(props) {
        super(props);
        this.modalClose = this.modalClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCategoryEdit = this.handleCategoryEdit.bind(this);
        this.handleDescriptionEdit = this.handleDescriptionEdit.bind(this);
        this.handleFacility = this.handleFacility.bind(this);
        this.desKey = this.desKey.bind(this);
        this.catKey = this.catKey.bind(this);
        this.state = {
            checkList: "",
            newFacility: "",
            warningMsg: "",
            height: 300,
        };
    }
    static defaultProps = {
        styleHide: {
            visibility: 'hidden',
            background: 'rgba(0,0,0,0)',
        },
        styleShow: {
            visibility: 'visible',
            background: 'rgba(0,0,0,0.5)',
        },
    };

    componentDidMount() {
        let checkList = this.props.checkList;
        this.setState({
            checkList: checkList
        });
        let modal = ReactDom.findDOMNode(this.refs.modal);
        let height = modal.clientHeight;
        this.setState({
            height: height
        });
    }
    handleCategoryEdit(e) {
        let categoryIndex = e.target.getAttribute('data-category');
        let checkList = this.state.checkList;

        if (categoryIndex != -1) {
            let value = e.target.value;

            checkList[this.props.index].categories[categoryIndex].category = value;
            this.setState({ checkList: checkList });
            if (value == "") {
                if (checkList[this.props.index].categories[categoryIndex].description.length == 0) {
                    checkList[this.props.index].categories.splice(categoryIndex, 1);
                    this.setState({ checkList: checkList });
                }
            }
            this.updateFacility();
        } else {
            let value = e.target.value;
            if (value != '') {
                if(!checkList[this.props.index].categories) checkList[this.props.index].categories = [];
                
                checkList[this.props.index].categories.push({
                    category: value,
                    description: [],
                });
                this.setState({ checkList: checkList });
                e.target.value = "";
                this.updateFacility();
            }
        }

    }
    handleFacility(e) {
        let value = e.target.value;
        this.setState({ newFacility: value });
    }
    updateFacility() {
        let editCheckList = this.props.editCheckList;
        let len = editCheckList.length;
        let isRepeat = false;
        for (let i = 0; i < len; i++) {
            if (this.props.editCheckList[i].facility == this.props.checkList[this.props.index].facility) {
                editCheckList[i] = this.state.checkList[this.props.index];
                condoSetAction.editCheckList(editCheckList);
                isRepeat = true;
                break;
            }
        }

        if (!isRepeat) {
            editCheckList.push(this.state.checkList[this.props.index]);
        }
    }
    catKey(e) {
        if (e.key == 'Enter') {
            this.handleCategoryEdit(e);
        }
    }
    desKey(e) {
        if (e.key == 'Enter') {
            this.handleDescriptionEdit(e);
        }
    }
    handleDescriptionEdit(e) {
        let categoryIndex = e.target.getAttribute('data-category');
        let desIndex = e.target.getAttribute('data-des');
        let checkList = this.state.checkList;
        let value = e.target.value;

        if (desIndex != -1) {
            if (value != '') {
                checkList[this.props.index].categories[categoryIndex].description[desIndex] = value;
                this.setState({ checkList: checkList });
            } else {
                checkList[this.props.index].categories[categoryIndex].description.splice(desIndex, 1);
                this.setState({ checkList: checkList });
            }
            this.updateFacility();
        } else {
            if (value != '') {
                checkList[this.props.index].categories[categoryIndex].description.push(value);
                this.setState({ checkList: checkList });
                e.target.value = "";
                this.updateFacility();
            }
        }
    }
    handleSubmit() {
        this.props.callBack(this.state.checkList, this.state.newFacility);
    }

    modalClose() {
        this.props.shouldModalClose(false);

    }
    renderDescription(ct, category) {
        let description = ct.description.map((des, index) => {
            return (
                <div className="form-group input-group-sm" key={index}>
                    <input type="text" className="form-control" value={des}
                        placeholder="Type description here" data-category={category} data-des={index} onChange={this.handleDescriptionEdit} />
                </div>
            )
        });
        return (
            <div>
                {description}
                <div className="form-group input-group-sm">
                    <input type="text" className="form-control"
                        placeholder="New description here" data-category={category} data-des={-1} onKeyDown={this.desKey} onBlur={this.handleDescriptionEdit} />
                </div>
            </div>
        )
    }
    renderCategory() {
        if (!this.state.checkList) return;
        let categories = this.state.checkList[this.props.index].categories;
        let content;
        if (categories) {
            content = categories.map((ct, index) => {
                return (
                    <div className="cl-wp" key={index}>
                        <div className="form-group">
                            <label >Category</label>
                            <input type="text" className="form-control" value={ct.category} id="category"
                                placeholder="Type category here" data-category={index} onChange={this.handleCategoryEdit} />
                        </div>
                        <div className="cl-ds-wp">
                            <label >Description</label>
                            {this.renderDescription(ct, index)}
                        </div>
                    </div>
                )
            });
        }
        return (
            <div>
                {content}
                <div className="cl-wp">
                    <div className="form-group">
                        <label htmlFor="condoName">New Category</label>
                        <input type="text" className="form-control" id="newCategory"
                            placeholder="New category" data-category={-1} onKeyDown={this.catKey} onBlur={this.handleCategoryEdit} />
                    </div>
                </div>
            </div>
        )
    }
    renderFacility() {
        return (
            <div>
                <div className="form-group">
                    <label htmlFor="condoName">New Facility</label>
                    <input type="text" className="form-control" id="newCategory"
                        placeholder="New Facility" onChange={this.handleFacility} />
                </div>
            </div>
        );
    }
    renderContent() {
        if (this.props.action == 0) {
            return (<div>Are you sure to remove?</div>);
        } else if (this.props.action == 1) {
            return this.renderCategory();
        } else {
            return this.renderFacility();
        }
    }
    render() {
        let style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
        let btnTxt = "";
        if (this.props.action == 0) {
            btnTxt = "Delete";
        } else if (this.props.action == 1) {
            btnTxt = "Update";
        } else if (this.props.action == 2) {
            btnTxt = "Add";
        }
        return (
            <div>
                <div className="report-shadow" style={style}></div>
                <div className="checkList-modal" style={{ visibility: style.visibility }} ref="modal">
                    <div className="modal-header">
                        <h4 className="modal-title" >{this.props.title}</h4>
                    </div>

                    <div className="modal-body" style={{ height: (this.state.height - 75 - 40) + "px" }}>
                        {this.renderContent()}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className={"btn " + (this.props.action != 0 ? "btn-info" : "btn-danger")} onClick={this.handleSubmit}>{btnTxt}</button>
                        <button type="button" className="btn btn-default" onClick={this.modalClose}>Cancel</button>
                    </div>
                </div>
            </div>
        );
    }
}


export default ModalCheckList;


// WEBPACK FOOTER //
// ./app/setComponents/condoSetComponents/modalCheckList.js